import { AfterContentChecked, Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[vfsDisabledControl]'
})
export class DisabledControlDirective implements OnChanges {
  @Input('vfsDisabledControl') condition: boolean;

  constructor(private ngControl: NgControl) {}

  ngOnChanges(changes: SimpleChanges): void {
    const action = this.condition ? 'disable' : 'enable';
    if (this.ngControl.control) {
      this.ngControl.control[action]();
    }
  }
}
